<app-header
  icon="fas fa-home"
  text="Startseite"
  sub="Individualisieren Sie die Inhalte Ihrer Atlas-Startseite."></app-header>
<p-divider />
@if (form) {
  <form [formGroup]="form" (ngSubmit)="submit()" class="p-fluid">
    <div class="grid">
      <app-form-field-wrapper
        [label]="'Überschrift'"
        [name]="'headline'"
        [colSize]="12">
        <input
          pInputText
          id="headline"
          type="text"
          formControlName="headline"
          class="p-input" />
      </app-form-field-wrapper>
      <app-form-field-wrapper
        [label]="'Hier können Sie einen kurzen Begrüßungstext eingeben!'"
        [name]="'startTeaser'"
        [colSize]="12">
        <input
          pInputText
          id="startTeaser"
          type="text"
          formControlName="startTeaser"
          class="p-input" />
      </app-form-field-wrapper>
    </div>
  </form>
  <p-divider />
}

<p-pickList
  class="app-pick-list"
  #listPickerCtrl
  filterBy="name"
  [source]="availableItems"
  [target]="selection"
  [dragdrop]="true"
  [responsive]="true"
  breakpoint="1400px"
  sourceFilterPlaceholder="durchsuchen ..."
  targetFilterPlaceholder="durchsuchen ..."
  [showSourceControls]="false"
  [sourceStyle]="{ height: '30rem' }"
  [targetStyle]="{ height: '30rem' }"
  (onMoveToSource)="saveToAtlasConfig()"
  (onTargetReorder)="saveToAtlasConfig()"
  (onMoveToTarget)="saveToAtlasConfig()"
  (onMoveAllToSource)="saveToAtlasConfig()"
  (onMoveAllToTarget)="saveToAtlasConfig()">
  <ng-template pTemplate="sourceHeader">
    <app-pick-list-header
      title="Themen, Berichte und Ansichten"
      [count]="availableItems.length"
      subtitle="Hier wählen Sie aus, welche Inhalte auf der Startseite angezeigt werden." />
  </ng-template>
  <ng-template pTemplate="targetHeader">
    <app-pick-list-header title="Startseite" [count]="selection.length" />
  </ng-template>
  <ng-template let-item pTemplate="item">
    <div class="pl-row">
      <i class="pl-icon" [class]="item.icon"></i>
      <div class="pl-body">
        <span class="pl-name">{{ item.name }}</span>
        <span class="pl-meta">{{ typeLabels[item.type] }}</span>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="emptymessagesource">
    <div class="pl-empty">Keine weiteren Einträge.</div>
  </ng-template>
  <ng-template pTemplate="emptyfiltermessagesource">
    <div class="pl-empty">Kein Eintrag passt zur Suche.</div>
  </ng-template>
  <ng-template pTemplate="emptymessagetarget">
    <div class="pl-empty">
      Noch nichts ausgewählt – per Doppelklick, Pfeil oder Ziehen übernehmen.
    </div>
  </ng-template>
  <ng-template pTemplate="emptyfiltermessagetarget">
    <div class="pl-empty">Kein Eintrag passt zur Suche.</div>
  </ng-template>
</p-pickList>
